import { DefaultButton } from '../buttons/default-button'
import * as styles from './error-boundary-fallback.css'

type ErrorBoundaryFallbackProps = {
  title: string
  detail: React.ReactNode
  onRetry: () => unknown
}

export const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({ title, detail, onRetry }) => (
  <div className={styles.container} role="alert">
    <p className={styles.title}>{title}</p>
    <p className={styles.detail}>{detail}</p>
    <DefaultButton buttonType="secondary" size="small" onClick={onRetry}>
      Retry
    </DefaultButton>
  </div>
)
